import { FadeIn } from "@/components/FadeIn";
import { Star, Quote } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Reviews = ({ reviews }) => {
  const { t, tc } = useLang();
  return (
    <section id="bewertungen" data-testid="reviews-section" className="py-24 md:py-32 bg-slate-50 border-y border-slate-200">
      <div className="container-x">
        <FadeIn className="max-w-2xl mb-14">
          <span className="overline">{t("reviews.overline")}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-4">{t("reviews.title")}</h2>
          <div className="flex items-center gap-3">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-blue-500 text-blue-500" />)}</div>
            <span className="text-slate-600">{t("reviews.google")}</span>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <FadeIn key={r.id || i} delay={(i % 3) * 0.08}>
              <div data-testid={`review-card-${i}`} className="card-light p-7 h-full flex flex-col">
                <Quote className="w-8 h-8 text-blue-600/30 mb-4" />
                <p className="text-slate-600 leading-relaxed flex-1">"{tc(r.text)}"</p>
                <div className="mt-5 pt-5 border-t border-slate-100 flex items-center justify-between">
                  <div>
                    <div className="text-slate-900 font-semibold">{r.author}</div>
                    <div className="text-xs text-slate-400">{r.source}</div>
                  </div>
                  <div className="flex">{[...Array(r.rating || 5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-blue-500 text-blue-500" />)}</div>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};
